<!-- OTPVerifyAgentRenewLicense -->
<template>
    <!-- start navigator -->
    <div class="container ps-lg-5 pe-lg-5 mt-1">
        <div class="row">
            <div class="
                col-12
                d-none d-lg-flex
                justify-content-between
                align-items-center
              ">
                <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">หน้าแรก</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
                        </li>
                        <li class="breadcrumb-item router-link active">
                            ขอต่ออายุใบอนุญาต
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    <!-- end navigator -->

    <div class="container-lg">
        <div class="row">
            <!-- Left Menu -->
            <div class="col-left-menu">
                <div class="left-menu">
                    <ul class="d-none d-lg-block">
                        <Menu />
                    </ul>
                </div>
            </div>
            <!-- Left Menu -->

            <div class="
              col-left-menu
              d-flex d-lg-none
              border-bottom
              align-items-center
              border-bottom
              w-100
              ps-3
              pe-3
            " style="background-color: #f2f2f2">
                <div class="icon-back">
                    <router-link to="/AgenteService">
                        <img src="@/assets/images/arrow-blue.svg" class="w-100" />
                    </router-link>
                </div>
                <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100 font-family blue-1">
                    ขอต่ออายุใบอนุญาต
                </div>
            </div>

            <div class="col">

                <StepBar :steps="['ตรวจสอบข้อมูล', 'อัปโหลดเอกสาร', 'ยืนยันการทำรายการ', 'ชำระเงิน', 'เสร็จสิ้น']"
                    :current="2" />

                <div class="title d-none d-lg-block border-bottom font-family blue-1">
                    ขอต่ออายุใบอนุญาต
                </div>

                <div class="container py-3 font-family-bla">
                    <div class="mx-auto otp-wrap">

                        <!-- เบอร์โทร & รหัสอ้างอิง -->
                        <div class="text-center mb-4">
                            <div class="mb-1">
                                หมายเลขโทรศัพท์ : <b>{{ maskedPhone }}</b>
                            </div>
                            <div>
                                รหัสอ้างอิง : <b>{{ reference }}</b>
                            </div>
                        </div>

                        <!-- ช่องกรอก OTP -->
                        <div class="mb-4">
                            <input ref="otpInput" v-model="otp" type="text" inputmode="text" maxlength="6"
                                class="form-control otp-input text-center" placeholder="กรอกรหัส OTP 6 หลัก"
                                pattern="[0-9]*" @input="otp = otp.replace(/[^0-9]/g, '')" @keyup.enter="handleEnter" />
                        </div>

                        <!-- ปุ่ม -->
                        <div class="d-flex justify-content-center gap-3 mb-3">
                            <button class="btn btn-secondary btn-confirm px-5" @click="goBack">ย้อนกลับ</button>
                            <button class="btn btn-bla btn-confirm px-5" :disabled="!otpReady"
                                @click="confirmOtp">ยืนยัน</button>
                        </div>

                        <!-- ข้อความกำกับ -->
                        <div class="text-center text-muted small mb-3">
                            รหัส OTP จะหมดอายุภายใน 5 นาที ในกรณีที่ท่านไม่ได้รับ SMS-OTP
                        </div>

                        <!-- ปุ่มขอรหัสใหม่ -->
                        <div class="text-center">
                            <button class="btn btn-outline-secondary btn-resend" :disabled="!canResend"
                                @click="resendOtp">
                                {{ canResend ? 'กดเพื่อขอรหัส OTP อีกครั้ง' : 'ขอรหัสใหม่ได้ใน ' + countdownText }}
                            </button>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>

    <div v-if="this.Loading">
        <LoadingBs5></LoadingBs5>
    </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { faCircleXmark, faFileLines } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

import StepBar from "./StepBar.vue";

import '@/styles/SweetAlert2CustomCSS.css';

export default {
    name: 'OTPVerifyAgentRenewLicense',
    components: {
        Menu,
        LoadingBs5,
        StepBar
    },
    data() {
        return {
            faCircleXmark: faCircleXmark,
            faFileLines: faFileLines,
            Loading: true,
            phoneNumber: '',
            reference: '',
            expireDate: null,
            otp: '',
            // นับถอยหลัง 5 นาที (วินาที)
            remain: 0,
            timer: null
        }
    },
    computed: {
        maskedPhone() { return this.phoneNumber },
        otpReady() { return this.otp.length === 6 },
        canResend() { return this.remain <= 0 },
        countdownText() {
            const m = Math.floor(this.remain / 60).toString().padStart(2, '0')
            const s = Math.floor(this.remain % 60).toString().padStart(2, '0')
            return `${m}:${s}`
        }
    },
    mounted() {
        if (this.$store.state.AgentCode == '') {
            this.$router.push('/');
        }

        this.Authorization();

        this.$refs.otpInput.focus();

        this.BindingData();

        this.startCountdown();
    },
    beforeUnmount() {
        clearInterval(this.timer)
    },
    methods: {
        BindingData() {
            this.phoneNumber = this.$store.state.AgentRenewLicense.verifyOTP.phoneNumber;
            this.reference = this.$store.state.AgentRenewLicense.verifyOTP.reference;
            this.expireDate = this.$store.state.AgentRenewLicense.verifyOTP.expireDate;
            this.otp = '';

            this.setRemainFromExpire(this.expireDate);
        },
        // แปลง expireDate (string จาก API) → remain (วินาที)
        setRemainFromExpire(expireDateStr, serverTimeStr = null) {
            const exp = this.parseIsoUtc(expireDateStr);

            // เวลา "ตอนนี้" ของไคลเอนต์ (ถ้าอยากชดเชย skew ก็ส่ง serverTimeStr มาด้วยได้)
            let nowClient = Date.now();
            if (serverTimeStr) {
                const serverNow = this.parseIsoUtc(serverTimeStr).getTime();
                const skewMs = serverNow - nowClient; // เซิร์ฟเวอร์เร็วกว่าเครื่อง = ค่าบวก
                nowClient += skewMs;
            }

            // ใช้ floor เพื่อให้เริ่มที่ 05:00 หรือ 04:59 ตามจริง (ไม่เด้ง 05:01)
            let diffSec = Math.floor((exp.getTime() - nowClient) / 1000);

            // ไม่ให้เกิน 300 และไม่ให้ติดลบ
            if (diffSec > 300) diffSec = 300;
            if (diffSec < 0) diffSec = 0;

            this.remain = diffSec;
        },
        // บังคับตีความเป็น UTC ถ้าไม่มีโซนในสตริง
        parseIsoUtc(s) {
            if (typeof s === 'string' && !s.endsWith('Z') && !/[+-]\d{2}:\d{2}$/.test(s)) {
                return new Date(s + 'Z'); // "2025-11-11T10:31:16" -> "2025-11-11T10:31:16Z"
            }
            return new Date(s);
        },
        startCountdown() {
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                if (this.remain > 0) this.remain--
                else clearInterval(this.timer)
            }, 1000)
        },
        goBack() {
            this.$router?.replace('/ReviewDraftAgentRenewLicense');
        },
        async handleEnter() {
            const canProceed = await this.Authentication('L01');
            if (!canProceed) {
                return; // หยุดการทำงานถ้ามีเอกสารอยู่แล้ว
            }

            if (this.otpReady) {
                this.confirmOtp()
            }
        },
        async confirmOtp() {
            const canProceed = await this.Authentication('L01');
            if (!canProceed) {
                return; // หยุดการทำงานถ้ามีเอกสารอยู่แล้ว
            }

            this.Loading = true;
            // TODO: เรียก API ตรวจสอบ OTP
            const request = {
                otp: this.otp,
                reference: this.reference
            };

            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.post(`AgencyERequest/AgentRenewLicenseVerifySMSOTP`, request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } })
                .then(async (response) => {
                    this.Loading = false;

                    if (response.status === 200) {
                        if (!response.data.Successed) {
                            Swal.fire({
                                icon: 'error',
                                html: '<label class="fs-4 fw-normal font-family">รหัส OTP ไม่ถูกต้อง</label>',
                                customClass: {
                                    popup: 'swal-wide',
                                    confirmButton: 'btn-bla'// pv-btn-primary
                                }
                            });
                        }
                        else {
                            this.$store.state.AgentRenewLicense.verifyOTP.otp = this.otp;
                            this.$store.state.AgentRenewLicense.verifyOTP.confirmOtp_Date = new Date().toLocaleString('th-TH');

                            this.Loading = true;
                            const res = await this.SaveAgentRenewLicense();
                            this.Loading = false;

                            if (!res || res.ok === false) return;

                            // ตรวจสอบการชำระค่าต่ออายุใบอนุญาต ก่อน
                            const renewal = this.$store.state?.AgentRenewLicense?.CanRequestLicenseRenewal?.renewal;
                            const isCheckPaymentAgentRenewLicense = this.$store.state?.AgentRenewLicense?.CanRequestLicenseRenewal?.trainingResultPayment === 'Y';

                            // this.$router?.push('/CheckPaymentAgentRenewLicense');// CheckPaymentAgentRenewLicense

                            if ([1, 2].includes(renewal) && isCheckPaymentAgentRenewLicense) {// เป็นต่ออายุใบอนุญาตที่ 1,2 และจ่ายเงินแล้ว
                                // API Save Data
                                this.Loading = true;
                                try {
                                    const res = await fetch(`${process.env.VUE_APP_URL_API}AgencyERequest/UpdateStatusAgentRenewLicense`, {
                                        method: "POST",
                                        headers: { Authorization: `Bearer ${AuthorizeToken}` },
                                        // ไม่มี body
                                    });
                                    this.isLoading = false;

                                    if (!res.ok) {
                                        console.error('[UpdateStatusAgentRenewLicense Response]', res);
                                        Swal.fire({
                                            icon: 'error',
                                            html: `<label class="fs-4 fw-normal font-family">ไม่สามารถบันทักข้อมูลได้ กรุณาติดต่อเจ้าหน้าที่</label>`,
                                            customClass: {
                                                popup: 'swal-wide',
                                                confirmButton: 'btn-bla'// pv-btn-primary
                                            }
                                        });
                                        return;
                                    }

                                    await this.$router.replace("/FinishAgentRenewLicense");// หน้า Thank You
                                } catch (err) {
                                    console.error('[UpdateStatusAgentRenewLicense]', err);
                                    Swal.fire({
                                        icon: 'error',
                                        html: `<label class="fs-4 fw-normal font-family">ไม่สามารถบันทักข้อมูลได้ กรุณาติดต่อเจ้าหน้าที่</label>`,
                                        customClass: {
                                            popup: 'swal-wide',
                                            confirmButton: 'btn-bla'// pv-btn-primary
                                        }
                                    });
                                    return;
                                }
                            } else {
                                this.$router?.replace('/CheckPaymentAgentRenewLicense');// CheckPaymentAgentRenewLicense
                            }

                        }
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            html: `<label class="fs-4 fw-normal font-family">${response.data.ErrorMessage}</label>`,
                            customClass: {
                                popup: 'swal-wide',
                                confirmButton: 'btn-bla'// pv-btn-primary
                            }
                        });
                    }
                }).catch((error) => {
                    this.Loading = false;
                    Swal.fire({
                        icon: 'error',
                        html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                        customClass: {
                            popup: 'swal-wide',
                            confirmButton: 'btn-bla'// pv-btn-primary
                        }
                    });
                });
        },
        // ใช้หลัง Resend OTP
        handleResendResponse(data, serverTimeStr) {
            const st = this.$store.state.AgentRenewLicense.verifyOTP;
            st.phoneNumber = data.phoneNumber;
            st.reference = data.reference;
            st.expireDate = data.expireDate;

            this.phoneNumber = data.phoneNumber;
            this.reference = data.reference;
            this.expireDate = data.expireDate;

            // คำนวณ remain ใหม่ แล้วเริ่มนับ
            this.setRemainFromExpire(data.expireDate, serverTimeStr);
            this.startCountdown();
        },
        resendOtp() {
            this.Loading = true;

            // Call API SendOTP
            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get(`AgencyERequest/AgentRenewLicenseSendOTP`, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                this.Loading = false;

                if (response.status === 200) {
                    // จะใช้หรือไม่ใช้ก็ได้ ถ้าอยากชดเชย clock skew
                    const serverTimeStr = response.headers?.date || null;
                    this.handleResendResponse(response.data, serverTimeStr);
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        html: `<label class="fs-4 fw-normal font-family">${response.data.ErrorMessage}</label>`,
                        customClass: {
                            popup: 'swal-wide',
                            confirmButton: 'btn-bla'// pv-btn-primary
                        }
                    });
                }
            }).catch((error) => {
                this.Loading = false;
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                    customClass: {
                        popup: 'swal-wide',
                        confirmButton: 'btn-bla'// pv-btn-primary
                    }
                });
            });
        },
        async SaveAgentRenewLicense() {
            const AuthorizeToken = localStorage.getItem('AuthorizeToken');

            const formData = new FormData();
            formData.append("ACCEPT_CONFIRM", this.$store.state.AgentRenewLicense.ConsentBySiteCode.ACCEPT_CONFIRM);
            formData.append("ACCEPT_CONFIRM_DT_STR", this.$store.state.AgentRenewLicense.ConsentBySiteCode.ACCEPT_CONFIRM_DT);
            formData.append("isRegisUnitLink", this.$store.state.AgentRenewLicense.preview.isRegisUnitLink);// ตรวจสอบว่ามีสิทธิ์ผู้ขึ้นทะเบียนขาย Unit-Linked ถ้าไม่มี = false
            formData.append("requestAgentRenewLicenseNo", this.$store.state.AgentRenewLicense.preview.dataResp.requestAgentRenewLicenseNo);// ต่ออายุครั้งที่เท่าไหร่
            formData.append("Photo", this.$store.state.AgentRenewLicense.uploadfile.files.photo);// รูปถ่ายหน้าตรงใช้ติดบัตร

            // หนังสือรับรองผ่านการอบรมหลักสูตรขอต่ออายุใบอนุญาตเป็นตัวแทนประกันชีวิต (วุฒิบัตร)
            for (let cert of this.$store.state.AgentRenewLicense.uploadfile.files.certs) {
                formData.append("Certs", cert); // key ต้องตรงกับ property
            }
            if (this.$store.state.AgentRenewLicense.uploadfile.qualification != null) {
                formData.append("qualification", this.$store.state.AgentRenewLicense.uploadfile.qualification);// มีคุณวุฒิหรือไม่? has=มี, none=ไม่มี, null=ไม่ใช่ต่อ 4
            }
            formData.append("isRenewAgentRegisUL", this.$store.state.AgentRenewLicense.preview.isRenewAgentRegis);// ต้องการต่ออายุการขึ้นทะเบียนตัวแทนประกันชีวิตควบการลงทุน (Unit Linked) ด้วยหรือไม่?
            formData.append("tc7CertAgree1", this.$store.state.AgentRenewLicense.tc7Cert.agree1);// อ่านคำรับรองคุณสมบัติ ตช.7
            formData.append("tc7CertAgree1_DateString", this.$store.state.AgentRenewLicense.tc7Cert.agree1_Date);
            formData.append("tc7CertAgree2", this.$store.state.AgentRenewLicense.tc7Cert.agree2);// อ่านคำรับรองคุณสมบัติ
            formData.append("tc7CertAgree2_DateString", this.$store.state.AgentRenewLicense.tc7Cert.agree2_Date);
            formData.append("confirmOtp_Date", this.$store.state.AgentRenewLicense.verifyOTP.confirmOtp_Date);
            formData.append("referenceOtp", this.$store.state.AgentRenewLicense.verifyOTP.reference);

            try {
                const response = await fetch(process.env.VUE_APP_URL_API + "AgencyERequest/SaveAgentRenewLicense", {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${AuthorizeToken}`
                    },
                    body: formData
                });

                if (response.ok) { // เทียบเท่า status 200-299
                    return response;
                } else {
                    Swal.fire({
                        icon: 'error',
                        html: '<label class="fs-4 fw-normal font-family">ไม่สามารถบันทึกข้อมูลได้ กรุณาติดต่อเจ้าหน้าที่</label>',
                        customClass: {
                            popup: 'swal-wide',
                            confirmButton: 'btn-bla'// pv-btn-primary
                        }
                    });
                    return { ok: false, error: response.data };
                }
            } catch (err) {
                console.error('[SaveData]', err);
                return { ok: false, error: err };
            }
        },
        async Authentication(SUBJOB) {
            try {
                const AuthorizeToken = localStorage.getItem("AuthorizeToken");
                const request = {
                    AGENTCODE: [],
                    SUBJOB: SUBJOB
                };

                const res = await http.post("AgencyERequest/CheckCreateJob?", request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } });

                if (res.data === '001' || res.data === '002') {
                    Swal.fire({
                        icon: 'error',
                        html: '<label class="fs-4 fw-normal font-family">ไม่สามารถทำรายการนี้ได้ เนื่องจากมีการร้องของานไปแล้วก่อนหน้า</label>',
                    }).then(() => {
                        this.$router.replace('/AgenteService');
                    });
                    return false; // มีเอกสารอยู่แล้ว
                }

                console.log('ยังไม่มีเอกสารที่สร้างไปก่อนหน้า');
                return true; // สามารถดำเนินการต่อได้

            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดของระบบ</label>',
                }).then(() => {
                    this.$router.replace("/AgenteService");
                });
                return false; // ไม่สามารถดำเนินการต่อได้
            }
        },
        Authorization() {
            this.Loading = true;

            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                if (response.status == 200) {
                    this.Loading = false;

                    this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
                    this.$store.state.AgentCode = response.data.AGENTCODE;
                }
                else {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
                }
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            });
        },
    }
}
</script>

<style scoped>
/* ปุ่ม: เต็มความกว้างบนมือถือ และกว้างพอดีบนจอใหญ่ */
.btn-confirm {
    width: 100%;
}

@media (min-width: 768px) {
    .btn-confirm {
        width: 25%;
        min-width: 160px;
        max-width: 320px;
    }
}

.font-family-bla {
    font-family: "DB Heavent", sans-serif;
}

/* กล่องรวมให้กว้างใกล้ภาพ */
.otp-wrap {
    max-width: 520px;
}

/* ช่อง OTP แบบขีดเส้นใต้กว้าง ๆ */
.otp-input {
    height: 56px;
    font-size: 1.25rem;
    border: none;
    border-bottom: 2px solid #212529;
    border-radius: 0;
    background: #f8f9fa;
}

.otp-input:focus {
    outline: none;
    box-shadow: none;
    border-bottom-color: #0d6efd;
}

/* ปุ่มทรง pill */
.btn-pill {
    border-radius: 999px;
    min-width: 140px;
}

/* ปุ่ม resend ให้คล้ายปุ่มกรอบเทาในภาพ */
.btn-resend {
    min-width: 260px;
    border-radius: 8px;
    background: #fff;
}

/* ปรับขนาดตัวหนังสือให้ใกล้เคียง */
b {
    font-weight: 700;
}
</style>